module.exports = __webpack_public_path__ + "img/nordycki_i.60635b23.jpg";